export enum BillingAccountOptionValues {
	INSTITUTION = 'INSTITUTION',
	DIOCESE = 'DIOCESE',
}

export enum TaxOptionValues {
    PRE = 'PRE',
    POST = 'POST',
}

export const billingAccountOptions = [
    {
        label: 'Institution',
        value: BillingAccountOptionValues.INSTITUTION,

    },
    {
        label: 'Diocese',
        value: BillingAccountOptionValues.DIOCESE,
    },
];


export const taxOptions = [
    {
        label: 'Pre Tax',
        value: TaxOptionValues.PRE,

    },
    {
        label: 'Post Tax',
        value: TaxOptionValues.POST,
    },
];
